import './BestPrice.scss';

import { b2x } from '@b2x/react/src';

export const BestPrice = (props: b2x.BestPriceProps) => <b2x.BestPrice {...props} />;
